import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { map, catchError, timeout } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { LocalStorageProvider } from '../_services/common/storage.service';
import { AuthService } from "../_services/pages/auth.service";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { API_ROUTES } from "../_constants/api-route.constant";


@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {

    constructor(
        private storageService: LocalStorageProvider,
        private authService: AuthService,
        private toastr: ToastrService,
        private loader: NgxUiLoaderService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!window.navigator.onLine) {
            this.toastr.error('You have No internet Connection.')
            return throwError(() => { return new HttpErrorResponse({ error: 'Internet is required.' }) })
        } else {
            let apiToken = this.storageService.getItem('token');
            let offset = new Date().getTimezoneOffset(), o = Math.abs(offset);
            // let timeZone = (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
            if (!request.headers.has('Content-Type') && request.url !== `${API_ROUTES.ACCOUNT.uploadImage}` && request.url !== `${API_ROUTES.UPLOAD.uploadPart}`) {
                request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
            }
            if (!request.headers.has('Accept')) {
                request = request.clone({ headers: request.headers.set('Accept', '*/*') });
            }
            if (!request.headers.has('Access-Control-Allow-Origin')) {
                request = request.clone({ headers: request.headers.set('Access-Control-Allow-Origin', '*') });
            }
            if (apiToken) {
                request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${apiToken}`) });
            }
            if(offset){
                request = request.clone({ headers: request.headers.set('Timezone-Offset', `${offset}`) });
            }
            if(!request.headers.has('timezone')){
                request= request.clone({headers: request.headers.set('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone)})
              }
            return next.handle(request).pipe(
                // timeout(155000),
                map((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                    }
                    return event;
                }),
                catchError((error: HttpErrorResponse) => {
                    if (error.message == "Timeout has occurred") {
                        this.toastr.error(error.message);
                        this.authService.logout();

                    } else {
                        if (error.status == 403 || error.status == 401 || error.status == 0) {
                            // this.toastr.error(error.statusText);
                            this.authService.logout();
                        }
                    }
                    return throwError(() => { return error; });
                })
            )
        }
    }
}